import { getUserProfileNavigationItems } from '../../../utility/navigationUtils';

export const getReportingRelationshipLabel = (
  labels,
  auth,
  accessControl,
  userId
) => {
  const { directReportsSet, indirectReportsSet } = accessControl ?? {};
  const isCurrentUser = auth.id === userId;

  const isDirectReport = directReportsSet.has(userId);
  const isInYourBranch = indirectReportsSet.has(userId);

  if (isCurrentUser) {
    return labels.you;
  } else if (isDirectReport) {
    return labels.yourDirectReport;
  } else if (isInYourBranch) {
    return labels.inYourBranch;
  }

  return null;
};

export const getNavItems = (
  labels,
  auth,
  accessControl,
  userId,
  organizationSettings
) => {
  const isCurrentUser = userId === auth.id;

  return getUserProfileNavigationItems(
    userId,
    auth,
    accessControl,
    organizationSettings
  ).reduce((navItems, currentNavItem) => {
    if (
      (currentNavItem.isVisibleToCurrentUser || !isCurrentUser) &&
      currentNavItem.hasOrganizationalVisibility
    ) {
      const name = labels.personNavItems[currentNavItem.translationKey];
      return [
        ...navItems,
        {
          ...currentNavItem,
          key: name,
          name,
        },
      ];
    }

    return navItems;
  }, []);
};
